import { Grid, Typography } from "@mui/material";
import { IError } from "itsf-ui-common";
import { useTranslation } from "react-i18next";
import { LabeledButton } from "@common/LabeledButton/LabeledButton";

interface IGenericErrorProps {
    error: IError;
    isHomePage?: boolean;
    retryFetch?(): void;
}

export const Error = (props: IGenericErrorProps) => {
    const {
        error: { errorMessage, status },
        isHomePage,
        retryFetch,
    } = props;
    const { t } = useTranslation("common");

    const is404 = status === 404;
    const is500 = status === 500;
    const canRetry = Boolean(retryFetch);

    const errorIcon = isHomePage ? require("../../static/img/error_home.png") : require("../../static/img/error.png");

    return (
        <Grid alignItems="center" container direction="column" justifyContent="center">
            <Grid
                item
                style={{ flex: "1 1 auto", display: "flex", flexDirection: "column", alignItems: "center" }}
                xs={12}
            >
                <img alt="error icon" src={errorIcon} style={{ height: "50px", width: "50px" }} />
                <Typography color="secondary" variant="h6">
                    {is404 ? t("notFoundErrorTitle") : t("genericErrorTitle")}
                </Typography>
                <Typography align="center" color="secondary">
                    {!is500 && errorMessage ? errorMessage : t("genericError")}
                </Typography>
            </Grid>
            {canRetry && (
                <Grid item style={{ flex: "1 1 auto", marginTop: 20 }} xs={12}>
                    <LabeledButton
                        color="inherit"
                        labelText={t("retry")}
                        type="submit"
                        variant="outlined"
                        onClick={retryFetch}
                    >
                        {t("retry")}
                    </LabeledButton>
                </Grid>
            )}
        </Grid>
    );
};
